<template>
  <div class="commerceContainer" @click="selectComercio">
    <ods-col :span="6">
    <ods-module class="modulo" :class="{ active: isActive }" style="margin-bottom: 8px;" >
  <div slot="header" class="clearfix" style="position: relative;">
    <span>{{ data.descomercio }}</span>
  </div>
  <div class="text item" >
    <p class="direction">Calle {{ data.nomvia | capitalize }} {{ data.numvia }}, {{ data.codpostal }}, {{ data.desprov | capitalize }}</p>
    <p class="info-comercio"> {{ data.numUsuarios }} Empleados / {{ data.numTPVs }} terminales</p>
  </div>
</ods-module>
</ods-col>
    <dialog-generic-error
      :message="errorMessage"
      :dialogError="dialogError"
      :before-close-fn="handleCloseSession"
      @dialogClosed="closeDialogError($event)"></dialog-generic-error>
  </div>
</template>

<script>
import DialogGenericError from '@/components/dialogs/DialogGenericError'

export default {
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      isActive: false,
      comercio: '',
      dialogError: false,
      hasErrors: false,
      errorMessage: '',
      loader: false,
      loaderListMov: false

    }
  },
  methods: {
    selectComercio () {
      const paramsPagina = JSON.stringify({
        pagina: 1
      })
      sessionStorage.setItem('appPagina', paramsPagina)
      this.$emit('primeraPagina', 1)
      this.listadoVuelta = {
        dcodcom: this.data.codcom,
        davanzar: 'false',
        dretroceder: 'false',
        dindMasDatos: '',
        dclaveInicio: '',
        dclaveFin: '',
        dpantPagina: 0
      }
      this.$emit('listadoPorDefecto', this.listadoVuelta)
      this.$emit('loader', true)
      for (var i = document.getElementsByClassName('modulo').length - 1; i >= 0; i--) {
        document.getElementsByClassName('modulo')[i].classList.remove('active')
      }
      document.getElementsByClassName('modulo')[this.data.registro_Numero - 1].classList.add('active')
      this.isActive = true
      this.comercio = this.data.codcom
      const paramsCadenaComercio = JSON.stringify({
        comercio: this.comercio,
        descomercio: this.data.descomercio,
        numComercio: this.data.registro_Numero
      })
      sessionStorage.setItem('appCadenaComercio', paramsCadenaComercio)
      this.$store.dispatch('listUsers', this.comercio).then(r => {
        this.executeTpvs()
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error in list Users - App', e)
      })
    },
    executeTpvs () {
      this.$store.dispatch('listTpv', { codcom: this.comercio }).then(r => {
        this.executeListProfile()
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        } else {
          if (r.vacio === true) {
            this.$emit('mostrarTpv', false)
          } else {
            this.$emit('mostrarTpv', true)
          }
        }
      }).catch(e => {
        console.error('Error in list Users - App', e)
      })
    },
    executeListProfile () {
      this.$store.dispatch('listProfile').then(r => {
        this.executeVisorTpvs()
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error in list Users - App', e)
      })
    },
    executeVisorTpvs () {
      this.$store.dispatch('listVisorTPVS', { codcom: this.comercio }).then(r => {
        this.executeListMovimientos()
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error in list TPVS - App', e)
      })
    },
    executeListMovimientos () {
      const data = {
        dcodcom: this.comercio,
        davanzar: 'false',
        dretroceder: 'false',
        dindMasDatos: '',
        dclaveInicio: '',
        dclaveFin: '',
        dpantPagina: 0
      }
      this.$store.dispatch('listMovimientos', data).then(r => {
        this.changeLoaderState()
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        } else {
          if (r.vacio === true) {
            this.$emit('mostrarListMov', false)
          } else {
            this.$emit('mostrarListMov', true)
          }
        }
        var clave = r.data.runServiceResponse.return.claveInicio
        var pos = 0
        pos = clave.indexOf('/')
        this.regTotales = parseInt(clave.substring(pos + 1))
        this.$emit('registrosTotales', this.regTotales)
      }).catch(e => {
        console.error('Error in list Movimientos - App', e)
      })
    },
    handleCloseSession () {
      this.$store.dispatch('logout')
    },
    closeDialogError (e) {
      this.dialogError = e
      this.handleCloseSession()
    },
    displayErrorDialog (msg) {
      this.errorMessage = `${msg}`
      this.dialogError = true
    },
    changeLoaderState () {
      this.$emit('loader', false)
    }
  },
  components: {
    DialogGenericError
  },
  mounted () {
    if (this.$route.query.comercio !== undefined || (this.$route.query.pantalla !== undefined && this.$route.query.pantalla === 'com')) {
      document.getElementsByClassName('modulo')[0].classList.add('active')
      this.isActive = true
    }
  }
}
</script>

<style lang='scss' scoped>
.direction {
    color: $--color-neutral-1;
}

.info-comercio {
    font-weight: $font-weight-regular;
    margin-top: 11px;
}

.icon-button {
      color: $--color-neutral-2;
}

/deep/ .ods-module {
  height: 130px;
  cursor: pointer;
}

/deep/ .ods-module__header {
    padding-bottom: 13px;
    padding-top: 20px;
    font-size: 14px;
    font-weight: $font-weight-medium;
}

.commerceContainer {
    width: 70%;
  }

  .active {
    border: solid rem(4) $--color-primary;
  }

</style>
